import axios from "axios";
import { handleApi} from "../utils/authentication";
import { getOAuthRedirectUri } from "../utils/oauthRedirect";
import { getIntegrationErrorMessage } from "../utils/oauthErrors";
import {store} from "../redux/store"

/*================================
Client Side Apis
=================================*/


//dashboard 




export const getDashboardPaidSocialMetrics = async (formData) => {
  try{
    let result=await handleApi(`get_dashboard_paid_social_metrics`,"POST",{},formData)
    if(result?.success){
      return result
    }
  }catch(error){
    throw error
  }
};


//check ads acc linked status

export const getAccountStatus = async () => {

  try{
    let result=await handleApi(`get_accounts_status`,"GET",{
      "Content-Type":"application/json"
    })
    
    if(result?.success){
      return result
    }
  }catch(error){
    throw error
  }
};

//Get Platform List

export const getPlatformList=async ()=>{
  try{
    let formData=null;
    let result=await handleApi(`get_platform_list`,"GET",{},formData)
    if(result){
      return result
    }
  }catch(error){

    return {success:false,error:error}
  }

}

//Get User Roles
export const getUserRoleList=async ()=>{
  try{
    let formData=null;
    let result=await handleApi(`get_user_roles`,"GET",{},formData)
    if(result){
      return result
    }
  }catch(error){

    return {success:false,error:error}
  }

}


//get_external_campaigns

export const getExternalCampaigns = async (platform_id) => {
  const formData=new FormData()
  formData.append('platform_id',platform_id)
  try{
    let result=await handleApi(`get_external_campaigns`,"POST",{},formData)
    if(result){
      return result
    }
  }catch(error){
    throw error
  }
};

//get_campaign ads

export const listCampaignAds = async (platform_id,external_campaign_id) => {
  const formData=new FormData()
  formData.append('platform_id',platform_id)
  formData.append('external_campaign_id',external_campaign_id)
  try{
    let result=await handleApi(`list_campaign_ads`,"POST",{},formData)
    if(result){
      return result
    }
  }catch(error){
    throw error
  }
};

//get_user_campaign_list

export const getUserCampaignList = async (platform_id,external_campaign_id,ads_id,program_id) => {
  let {user}=store.getState()
  const formData=new FormData()
 // console.log("called")
  // formData.append('client_id',user?.client_id)
  // formData.append('user_id',user?.user_id)
  // formData.append('role_id',user?.role_id)
  formData.append('platform_id',platform_id)
  formData.append('program_id',program_id)
  formData.append('external_campaign_id',external_campaign_id)
  formData.append('ads_id',ads_id)
  try{
    let result=await handleApi(`get_user_campaign_list`,"POST",{},formData)
    if(result){
      return result
    }
  }catch(error){
    throw error
  }
};


//link_external_ads_with_internal_campaign
export const updateCampaignAssociateStatus = async (formData) => {
  try {
    let result = await handleApi(
      "link_external_ads_with_internal_campaign",
      "POST",
      {},
      formData
    );
    if (result) {
     return result
    }
  } catch (error) {
    throw error
  }
};




//fetch credential for connecting to ad account

export const fetchCredentials = async  () => {
  try{
    let result=await handleApi(`google_ads_env_variables`,"GET",{
      "Content-Type":"application/json"
    })
    
    if(result)
    {
      return result
    }
    }
  catch(e)
  {
    throw e
  }
};

// export const fetchCredentials = async  () => {
//   try{
//     let result=await handleApi(`google_ads_env_variables`,"GET",{
//       "Content-Type":"application/json"
//     })
    
//     if(result?.success)
//     {
//       return {
//         CLIENT_ID:result?.google?.google_ads_client_id,
//         CLIENT_SECRET:result?.google?.google_ads_client_secret,
//         DEVELOPER_TOKEN:result?.google?.google_ads_developer_token,
//         REDIRECT_URI: `${process.env.REACT_APP_URL}client/integrations`,
//         GRANT_TYPE: "authorization_code",
//       };
//     }
//     else{
//       return {
//         CLIENT_ID:'',
//         CLIENT_SECRET:'',
//         REDIRECT_URI: '',
//         DEVELOPER_TOKEN:'',
//         GRANT_TYPE: "authorization_code",
//       };
//     }
//     }
//   catch(e)
//   {
//     return   {
//       CLIENT_ID:'',
//       CLIENT_SECRET:'',
//       REDIRECT_URI: '',
//       GRANT_TYPE: "authorization_code",
//     }
//   }
// };

//for asociateing and disAsociating external ad account with internal ad account



//Notigication appis

export const getNotifications = async (client_id) => {
const data={client_id}

  try{
    const result = await handleApi('get_campaign_notifications', 'POST', {
      'Content-Type': 'application/json',
    }, JSON.stringify(data))

    if(result){
      return result
    }
  }catch(error){
    throw error
  }
};

export const updateNotification = async (notification_id) => {
  const data={notification_id}
    try{
      const result = await handleApi('update_notification', 'POST', {
        'Content-Type': 'application/json',
      }, JSON.stringify(data))
  
      if(result){
        return result
      }
    }catch(error){
      throw error
    }
  };
  
/*=========================================
Google ads integation apis 
==========================================*/



export const getAuthToken = async (authCode) => {
  const redirectUri = getOAuthRedirectUri();

  if (authCode) {
    const storedCode = localStorage.getItem('google_code');
    if (storedCode && storedCode === authCode) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[Google OAuth Dev] Skipping duplicate code token exchange');
      }
      return;
    }
    localStorage.setItem('google_code', authCode);

    try {
      if (process.env.NODE_ENV === 'development') {
        console.log('[Google OAuth Dev] Exchanging code via backend', { redirect_uri: redirectUri });
      }

      const formData = new FormData();
      formData.append('code', authCode);
      formData.append('redirect_uri', redirectUri);

      const response = await handleApi('google_ads_exchange_code', 'POST', {}, formData);

      if (process.env.NODE_ENV === 'development') {
        console.log('[Google OAuth Dev] google_ads_exchange_code response', response);
      }

      if (!response?.success) {
        throw response;
      }

      return response;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[Google OAuth Dev] Google token exchange failed', error);
      }
      throw error;
    }
  }
};

export const getGoogleAdsErrorMessage = (error, fallback = 'Failed to connect Google Ads') =>
  getIntegrationErrorMessage(error, fallback);

export const fetchAccessibleCustomers = async () => {
  try {
    const result = await handleApi("google_ads_accessible_customers", "GET", {
      "Content-Type": "application/json",
    });

    if (!result || result?.success === false) {
      throw result || { success: false, error: { error_message: 'Failed to list Google Ads accounts.' } };
    }

    return result;
  } catch (error) {
    console.error("Error fetching accessible customers:", error);
    throw error;
  }
};

export const searchCustomerAccounts = async (
  customerId,
) => {
  try {
    const formData = new FormData();
    formData.append("customer_id", customerId);

    const result = await handleApi("google_ads_customer_accounts", "POST", {}, formData);

    if (result?.success === false) {
      throw result;
    }

    return result;
  } catch (error) {
    console.error("Error fetching customer accounts:", error);
    throw error;
  }
};

//searchClientAccountsAssociatedWithManager

export const searchManagerAccounts = async (
  customerId,
) => {
  try {
    const formData = new FormData();
    formData.append("customer_id", customerId);

    const result = await handleApi("google_ads_manager_accounts", "POST", {}, formData);

    if (result?.success === false) {
      throw result;
    }

    return result;
  } catch (error) {
    console.error("Error fetching manager accounts:", error);
    throw error;
  }
};

//link searchClientAccountAssociatedWithManager to manager acc and connect to google ads A/c

export const linkAdsAccount = async (manager_id, user_id,user) => {
  const headers = {
    token:user?.token
      // "eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOiIyMDI0LTA5LTE4IDEwOjE1OjA0IiwidXNlcl9pbmZvIjp7InVzZXJfaWQiOjMsImNsaWVudF9pZCI6Nn19.TXCG_mUTZa_nKwZqPxBe9WK67yUpk0vS2cgMY8vXdoI",
  };
  const body = {
    google_user_id: user_id,
    google_manager_id: manager_id,
  };

  if (manager_id && user_id) {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}update_google_ads_user_info`, body, { headers });
      return response.data; // Return the customers data
    } catch (error) {
      console.error("Error link the account:", error);
      throw error; // Propagate the error
    }
  }
};

//after linked with manager acc to google ads acc, click on get associated campaigns

export const getGoogleAdsCampaignList = async () => {

  try{
    let result=await handleApi(`google_ads_campaign_list`,"POST",{
      "Content-Type":"application/json"
    })
    
    if(result?.success){
      return result
    }
  }catch(error){
    throw error
  }
};

//get the internal Campaign  list to link with associated external campaign

export const getInternalCampaignList = async (user) => {
  // Set up the data object conditionally
  const data = user?.program_id
    ? {
        program_id: user?.program_id,
        role_id: user?.role_id,
        user_id: user?.user_id,
      }
    : {
        client_id: user?.client_id,
        role_id: user?.role_id,
        user_id: user?.user_id,
      };

  try {
    // Make the API request
    const result = await handleApi('get_user_campaign_list', 'POST', {
      'Content-Type': 'application/json',
    }, JSON.stringify(data));

    if(result){
      return result
    }
  } catch (error) {
    console.error('Error fetching campaign list:', error);
    throw error; // Rethrow the error for handling in the calling code
  }
};

/*=========================================
LinkedIn ads integation apis 
==========================================*/

export const fetchAuthCodeFromLinkedIn = async (client_id, redirect_uri, scope) => {
  const encodedRedirectUri = encodeURIComponent(redirect_uri || getOAuthRedirectUri());
  const encodedScope = encodeURIComponent(scope || '');
  const encodedState = encodeURIComponent('u_intel_linkedin_oauth');
  const API_URL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${client_id}&redirect_uri=${encodedRedirectUri}&state=${encodedState}&scope=${encodedScope}`;
  window.location.href = API_URL;
};

export const fetchLinkedInAdAccounts = async (code, account_type) => {
  try {
    if (!code) {
      throw { success: false, error: { error_message: 'Authorization code is required.' } };
    }

    if (!account_type || !['ads', 'posts'].includes(account_type)) {
      throw { success: false, error: { error_message: 'Account type is required.' } };
    }

    const storedCode = localStorage.getItem('linkedin_code');
    if (storedCode && storedCode === code) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[LinkedIn OAuth Dev] Skipping duplicate code API call', {
          account_type,
          code_prefix: `${code?.slice(0, 12)}...`,
        });
      }
      return { success: false, error: { error_message: 'Authorization code already processed.' } };
    }

    localStorage.setItem('linkedin_code', code);

    if (process.env.NODE_ENV === 'development') {
      console.log('[LinkedIn OAuth Dev] Calling create_linkedin_ads_token', {
        account_type,
        redirect_uri: getOAuthRedirectUri(),
      });
    }

    const formData = new FormData();
    formData.append('code', code);
    formData.append('account_type', account_type);
    formData.append('redirect_uri', getOAuthRedirectUri());

    const result = await handleApi('create_linkedin_ads_token', 'POST', {}, formData);

    if (process.env.NODE_ENV === 'development') {
      console.log('[LinkedIn OAuth Dev] create_linkedin_ads_token response', result);
    }

    if (!result?.success) {
      throw result;
    }

    return result;
  } catch (error) {
    console.error('[LinkedIn OAuth Dev] fetchLinkedInAdAccounts failed', error);
    throw error;
  }
};

 export const linkLinkedinAdsAccount = async (linkedin_ads_account_id) => {
  try {
    const endPoint=`update_linkedin_ads_user_info`
    const method='POST'
    const headers = {};
    let formData = new FormData()
    formData.append('linkedin_ads_account_id',linkedin_ads_account_id)
    const result = await handleApi(endPoint,method,headers,formData) 
      if(result){
      return result
    }
  } catch (error) {
    console.error('Error fetching LinkedInAdsAcc:', error);
    throw error; // Rethrow the error for handling in the calling code
  }
 }


 export const getlinkedinAdsCampaignList = async () => {

  try{
    let result=await handleApi(`linkedin_ads_campaign_list`,"GET",{
      "Content-Type":"application/json"
    })
    
    if(result?.success){
      return result
    }
  }catch(error){
    throw error
  }
};

/*=========================================
Snapchat ads integation apis 
==========================================*/

export const fetchAuthCodeFromSnapchat = (client_id, redirect_uri) => {
  try {
    const encodedRedirectUri = encodeURIComponent(redirect_uri);
    const scope = encodeURIComponent(
      'snapchat-marketing-api snapchat-offline-conversions-api snapchat-profile-api',
    );
    const API_URL = `https://accounts.snapchat.com/login/oauth2/authorize?client_id=${client_id}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=${scope}`;

    if (process.env.NODE_ENV === 'development') {
      console.log('[Snapchat OAuth Dev] Redirecting to authorize', { redirect_uri });
    }

    window.location.href = API_URL;
  } catch (e) {
    console.error(e);
  }
};

//get 
export const getOrganizationList = async (code) => {
  try {
    if (!code) {
      throw { success: false, error: { error_message: 'Authorization code is required.' } };
    }

    const snapchatCode = localStorage.getItem('snapchat_code');
    if (snapchatCode && code === snapchatCode) {
      if (process.env.NODE_ENV === 'development') {
        console.log('[Snapchat OAuth Dev] Skipping duplicate code API call');
      }
      return { success: false, error: { error_message: 'Authorization code already processed.' } };
    }

    localStorage.setItem('snapchat_code', code);

    const endPoint = 'create_snapchat_ads_token';
    const method = 'POST';
    const headers = {};
    const data = new FormData();
    data.append('code', code);
    data.append('redirect_uri', getOAuthRedirectUri());

    if (process.env.NODE_ENV === 'development') {
      console.log('[Snapchat OAuth Dev] Calling create_snapchat_ads_token', {
        redirect_uri: getOAuthRedirectUri(),
        code_prefix: `${code?.slice(0, 12)}...`,
      });
    }

    const response = await handleApi(endPoint, method, headers, data);

    if (process.env.NODE_ENV === 'development') {
      console.log('[Snapchat OAuth Dev] create_snapchat_ads_token response', response);
    }

    if (!response?.success) {
      throw response;
    }

    return response;
  } catch (e) {
    console.error('[Snapchat OAuth Dev] getOrganizationList failed', e);
    throw e;
  }
};

//get snapchat Ad Accounts


export const getSnapchatAdAccounts=async (organisation_id)=>{
  try{
    if(organisation_id!="")
    {
      let endPoint="get_snapchat_ad_accounts"
      let method="POST"
      let headers={}
      let data=new FormData()
      data.append('organization_id',organisation_id)
      let response=await handleApi(endPoint,method,headers,data)
      return response;
    }

    return {success:false,error:"Organisation-Id is required"}
  }
  catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }

}

export const linkSnapchatAdAccount=async (snapchat_user_info)=>{
  try{
    if(snapchat_user_info?.organization_id && snapchat_user_info?.ad_accounts_id)
      {
        let endPoint="update_snapchat_ads_user_info"
        let method="POST"
        let headers={}
        let data=new FormData()
        data.append('organization_id',snapchat_user_info?.organization_id)
        data.append('ad_accounts_id',snapchat_user_info?.ad_accounts_id)
        let response=await handleApi(endPoint,method,headers,data)
        return response;
      }
  
      return {success:false,error:"Organisation-Id and Ad Accounts Id  is required"}
    


  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}

/*=========================================
Spotify ads integation apis 
==========================================*/

export const fetchAuthCodeFromSpotify = (client_id, redirect_uri) => {
  try {
    const encodedRedirectUri = encodeURIComponent(redirect_uri || getOAuthRedirectUri());
    const API_URL = `https://accounts.spotify.com/authorize?client_id=${client_id}&response_type=code&redirect_uri=${encodedRedirectUri}`;

    if (process.env.NODE_ENV === 'development') {
      console.log('[Spotify OAuth Dev] Redirecting to authorize', { redirect_uri: redirect_uri || getOAuthRedirectUri() });
    }

    window.location.href = API_URL;
  } catch (e) {
    console.error('[Spotify OAuth Dev] Authorize redirect failed', e);
  }
};

export const getSpotifyAdAccountList = async (code) => {
  try {
    if (!code) {
      throw { success: false, error: { error_message: 'Authorization code is required.' } };
    }

    const storedCode = localStorage.getItem('spotify_code');
    if (storedCode && storedCode === code) {
      return { success: false, error: { error_message: 'Authorization code already processed.' } };
    }
    localStorage.setItem('spotify_code', code);

    const endPoint = 'create_spotify_ads_token';
    const method = 'POST';
    const headers = {};
    const data = new FormData();
    data.append('code', code);
    data.append('redirect_uri', getOAuthRedirectUri());

    const response = await handleApi(endPoint, method, headers, data);

    if (!response?.success) {
      throw response;
    }

    return response;
  } catch (e) {
    console.error('[Spotify OAuth Dev] getSpotifyAdAccountList failed', e);
    throw e;
  }
};

  export const linkSpotifyAdAccount=async (ad_accounts_id)=>{
    try{
      if(ad_accounts_id=="")
        {
          return {success:false,error:"Ad Account Id is required"}
      
        }
       let endPoint="update_spotify_ads_user_info"
        let method="POST"
        let headers={}
        let data=new FormData()
        data.append('ad_account_id',ad_accounts_id)
        let response=await handleApi(endPoint,method,headers,data)
        return response;
      }
      catch(e)
      {
        console.log(e)
        return {success:false,error:e}
      }

  }


  /*=====================================================
  GOOGLE ANALYTICS
  =====================================*/

export const  getGoogleAnalyticsAccounts=async (code)=>{
  try{
    if(code==="")
      {
        return {success:false,error:"Code is required"}
    
      }
     let endPoint="create_google_analytics_token"
      let method="POST"
      let headers={}
      let data=new FormData()
      data.append('code',code)
      let response=await handleApi(endPoint,method,headers,data)
      return response;
    }
    catch(e)
    {
      console.log(e)
      return {success:false,error:e}
    }

}

export const linkGoogleAnalyticsAccount=async (account)=>{
  try{
    if(!account?.account_id || !account?.display_name)
    {
      return {success:false,error:"Account Id and Name is required"}
    }
    let endPoint="update_google_analytics_user_info"
    let method="POST"
    let headers={}
    let data=new FormData()
    data.append('google_analytics_account_id',account?.account_id)
    data.append('display_name',account?.display_name)
    let response=await handleApi(endPoint,method,headers,data)
    return response;

  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}

export const getGoogleAnalyticsPropertylist=async ()=>{
  try{

    let endPoint="get_google_analytics_properties"
    let method="GET"
    let headers={}
   let response=await handleApi(endPoint,method,headers,null)
    return response;

  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}
export const getGoogleAnalyticsPropertyDetails=async (property_id)=>{
  try{
    if(property_id==="" || !property_id)
      {
        return {success:false,error:"Property Id  is required"}
      }

    let endPoint="get_google_analytics_property_details"
    let method="POST"
    let headers={}
    let data=new FormData()
    data.append('property_id',property_id)
   let response=await handleApi(endPoint,method,headers,data)
    return response;

  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}


export const updateGoogleAnalyticsPropertyDetails=async (property,websites)=>{
  try{
    
    if(property!=null )
    {
        

   
      let endPoint="update_google_analytics_property"
      let method="POST"
      let headers={}
      let data=new FormData()
      data.append('property_id',property?.property_id)
      data.append('property_name',property?.property_name)
      data.append('google_analytics_account_id',property?.google_analytics_account_id)
      data.append('display_name',property?.display_name)
      let count=0;
      if(websites?.length>0)
      {
        websites.forEach((element,index) => {
          if(element?.url!="")
          {
            data.append(`websites[${count}]`,element?.url)
            count++;
  
          }
        
          
        });

      }else{
        data.append('websites',[])
      }

      let response=await handleApi(endPoint,method,headers,data)
    //  console.log(response)
      return response;

    }
    



  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}



export const getGoogleAnalyticsWebsiteMetrics=async (property,websites_url)=>{
  try{
    if(property!=null && websites_url!="")
    {

      let endPoint="get_google_analytics_website_metrics"
      let method="POST"
      let headers={}
      let data=new FormData()
      data.append('property_id',property?.property_id)
      data.append('website_url',websites_url)
     let response=await handleApi(endPoint,method,headers,data)
     return response;
    }else{
      return {success:false,message:"Property Id and Website URL required"}
    }
    

  }catch(e)
  {
    console.log(e)
    return {success:false,error:e}
  }
}


/*=====================================================
   Facebook Ads Integration
  =====================================*/

  export const storeFacebookIntegrationCredentials=async (values)=>{
    try{
      const redirectUri = getOAuthRedirectUri();
      const formData=new FormData()
      formData.append('account_type',values?.account_type)
      formData.append('redirect_uri', redirectUri)

      if (process.env.NODE_ENV === 'development') {
        console.log('[Facebook OAuth Dev] Storing credentials', {
          redirect_uri: redirectUri,
          account_type: values?.account_type,
        });
      }

      let endPoint="store_facebook_credentials"
      let method="POST"
      let headers={}

      let result=await handleApi(endPoint,method,headers,formData)
      
      if(result?.success)
      {
        const creds = result?.data?.facebook_credentials;
        const oauthRedirectUri = encodeURIComponent(redirectUri || creds?.redirect_uri || '');
        const scope = encodeURIComponent((creds?.scope || '').trim());
        const state = encodeURIComponent((creds?.state || '').trim());
        const clientId = (creds?.facebook_client_id || '').trim();
        let API_URL=`https://www.facebook.com/v21.0/dialog/oauth?client_id=${clientId}&redirect_uri=${oauthRedirectUri}&state=${state}&scope=${scope}&response_type=${creds?.response_type || 'code'}`

        if (process.env.NODE_ENV === 'development') {
          console.log('[Facebook OAuth Dev] Redirecting to Meta OAuth', { redirect_uri: redirectUri });
        }

        window.location.href=API_URL
     } else {
        throw result;
     }
     return result
    

    }catch(e)
    {
      console.error('[Facebook OAuth Dev] storeFacebookIntegrationCredentials failed', e);
      return {success:false,message:e?.message,error:e}
    }
  }



  export const getFacebookAdAccounts = async (code, account_type) => {
    try {
      if (!code) {
        throw { success: false, error: { error_message: 'Authorization code is required.' } };
      }

      if (!account_type || !['ads', 'posts'].includes(account_type)) {
        throw { success: false, error: { error_message: 'Account type is required.' } };
      }

      const storedCode = localStorage.getItem('facebook_code');
      if (storedCode && storedCode === code) {
        if (process.env.NODE_ENV === 'development') {
          console.log('[Facebook OAuth Dev] Skipping duplicate code API call', { account_type });
        }
        return { success: false, error: { error_message: 'Authorization code already processed.' } };
      }

      localStorage.setItem('facebook_code', code);

      const formData = new FormData();
      formData.append('code', code);
      formData.append('account_type', account_type);
      formData.append('redirect_uri', getOAuthRedirectUri());

      if (process.env.NODE_ENV === 'development') {
        console.log('[Facebook OAuth Dev] Calling create_facebook_ads_token', {
          account_type,
          redirect_uri: getOAuthRedirectUri(),
        });
      }

      const response = await handleApi('create_facebook_ads_token', 'POST', {}, formData);

      if (!response?.success) {
        throw response;
      }

      return response;
    } catch (e) {
      console.error('[Facebook OAuth Dev] getFacebookAdAccounts failed', e);
      throw e;
    }
  };

  export const linkFacebookAdsAccount=async (ad_account_id)=>{
    try{
      if(ad_account_id==="")
      {
        return {success:false,error:"Account Id and Name is required"}
      }
      let endPoint="update_facebook_ads_user_info"
      let method="POST"
      let headers={}
      let data=new FormData()
      let account_type=localStorage.getItem('account_type')
      data.append('account_type',account_type)
      data.append('ad_account_id',ad_account_id)
    
      let response=await handleApi(endPoint,method,headers,data)
      return response;
  
    }catch(e)
    {
      console.log(e)
      return {success:false,error:e}
    }
   
  }


  // --------------------------------------------------------
  //  INSTAGRAM INTEGRATION
  // -------------------------------------------------------------
  
  export const storeInstagramIntegrationCredentials=async ()=>{
    try{
      const redirectUri = getOAuthRedirectUri();
      const formData=new FormData()
      formData.append('redirect_uri', redirectUri)

      if (process.env.NODE_ENV === 'development') {
        console.log('[Instagram OAuth Dev] Storing credentials', { redirect_uri: redirectUri });
      }

      let endPoint="store_instagram_credentials"
      let method="POST"
      let headers={}

      let result=await handleApi(endPoint,method,headers,formData)
      
      if(result?.success)
      {
        const instagram_credentials = result?.data?.instagram_credentials;
        const clientId = encodeURIComponent((instagram_credentials?.instagram_client_id || '').trim());
        const oauthRedirectUri = encodeURIComponent(redirectUri || instagram_credentials?.redirect_uri || '');
        const scope = encodeURIComponent((instagram_credentials?.scope || '').trim());
        const state = encodeURIComponent((instagram_credentials?.state || 'u_intel_instagram_oauth').trim());
        const responseType = encodeURIComponent(instagram_credentials?.response_type || 'code');

        const API_URL = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${clientId}&redirect_uri=${oauthRedirectUri}&state=${state}&scope=${scope}&response_type=${responseType}`;

        if (process.env.NODE_ENV === 'development') {
          console.log('[Instagram OAuth Dev] Redirecting to Meta OAuth', { redirect_uri: redirectUri });
        }

        window.location.href = API_URL;
      } else {
        throw result;
      }

      return result;
    } catch(e) {
      console.error('[Instagram OAuth Dev] storeInstagramIntegrationCredentials failed', e);
      throw e;
    }
  }
  
  export const getInstagramAdAccounts=async (code)=>{
    try{
      if(!code) {
        throw { success: false, error: { error_message: 'Authorization code is required.' } };
      }

      const storedCode = localStorage.getItem('instagram_code');
      if (storedCode && storedCode === code) {
        return { success: false, error: { error_message: 'Authorization code already processed.' } };
      }
      localStorage.setItem('instagram_code', code);

      let endPoint="create_instagram_ads_token"
      let method="POST"
      let headers={}
      let data=new FormData()
      data.append('code', code)
      data.append('redirect_uri', getOAuthRedirectUri())

      const response = await handleApi(endPoint, method, headers, data);

      if (!response?.success) {
        throw response;
      }

      return response;
    } catch(e) {
      console.error('[Instagram OAuth Dev] getInstagramAdAccounts failed', e);
      throw e;
    }
  }
















/*=========================================
Super-admin apis 
==========================================*/

// API Health Check
export const checkApiHealth = async () => {
  try {
    const result = await handleApi('check_api_health', 'GET', {
      'Content-Type': 'application/json',
    });
    return result;
  } catch (error) {
    console.error('Error checking API health:', error);
    throw error;
  }
};

export const getDashboardData = async (interval, fromDate, toDate) => {
  try {
    let endPoint = 'get_dashboard_data';  // Default endpoint

    // Check if interval is provided
    if (interval) {
      endPoint += `?time_interval=${interval}`;
    }
    // If interval is not provided, check for date range
    else if (fromDate && toDate) {
      endPoint += `?from_date=${fromDate}&to_date=${toDate}`;
    }
    // Allow the option to pass only fromDate or only toDate
    else if (fromDate) {
      endPoint += `?from_date=${fromDate}`;
    }
    else if (toDate) {
      endPoint += `?to_date=${toDate}`;
    }

    // Fetch the data from API
    const result = await handleApi(endPoint, 'GET', {
      'Content-Type': 'application/json',
    });

    return result;

  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const getDashboardDetails = async (type, interval, fromDate, toDate, clientId = null) => {
  try {
    const formData = new FormData();
    formData.append('type', type);
    
    if (clientId) {
      formData.append('client_id', clientId);
    }
    if (interval) {
      formData.append('time_interval', interval);
    }
    if (fromDate) {
      formData.append('from_date', fromDate);
    }
    if (toDate) {
      formData.append('to_date', toDate);
    }

    const result = await handleApi('get_dashboard_details', 'POST', {}, formData);
    return result;

  } catch (error) {
    console.error('Error fetching dashboard details:', error);
    throw error;
  }
};




/*------------- Fetch Ads------------------*/
export const fetchAds=async (platform_id)=>{
  try{
    let endpoint="list_all_ads"
    let method="POST"
    let formData=new FormData()
    let headers={}
    formData.append('platform_id',platform_id)
    let result=await handleApi(endpoint,method,headers,formData)
    if(result?.success)
    {
      return result;
    }else{
      return {success:false,message:"Failed to list ADS"}
    }

  }catch(e)
  {
    console.log(e)
    return {success:false,message:"Failed to list ADS" ,error:e?.message}
  }

}



//driver.js tour
export const updateApplicationTourStatus = async (user) => {
  try {

 

    if(!user || !user?.user_id || !user?.client_id || user?.has_seen_tour===undefined)
    {
      return {success:false,message:"User is required"}
    }
   

    const formData = new FormData()
    formData.append('user_id', user?.user_id)
    formData.append('client_id', user?.client_id)
    formData.append('has_seen_tour', user?.has_seen_tour)
    let result = await handleApi('update_application_tour_status', 'POST', {}, formData)
 
    if (result?.success) {
    
      return {success:true,message:"Tour status updated",data:result?.data}
    }else{
      return {success:false,message:"Failed to update tour status",error:result?.error}
    }

  } catch (e) {
    console.log(e)
    return {success:false,message:"Failed to update tour status",error:e?.message}
  }

}








